import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useSubmitAssignmentMutation } from '../../features/assignmentMark/assignmentMarkApi';

const AssignmentModalContent = ({ assignmentData, user, setIsOpen }) => {
    const [submitAssignment, { isError, isLoading, isSuccess }] = useSubmitAssignmentMutation()
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const onSubmit = data => {

        if (user.role === 'admin') {
            toast.error('sorry admin cannot submit assignment ')
            return
        }
        const mainData = {
            student_id: user.id,
            student_name: user.name,
            assignment_id: assignmentData.id,
            title: assignmentData.title,
            createdAt: new Date(),
            totalMark: assignmentData.totalMark,
            mark: 0,
            repo_link: data.repo_link,
            status: "pending"
        }
        submitAssignment(mainData)
    };
    useEffect(() => {
        if (isSuccess) {
            toast.success("Assignment submitted successfully")
            setIsOpen(false)
        }
        if (isError) {
            toast.error("Something went wrong")
        }
    }, [isSuccess, isError])
    return (
        <div className=''>
            <h1 className='text-xl mb-3 font-bold text-center '>{assignmentData.title}</h1>

            <form onSubmit={handleSubmit(onSubmit)} >
                <label htmlFor="repo" className='mb-2 block' >Enter your repository link</label>
                <input  {...register("repo_link", { required: true })} id='repo' type="text" className='w-full py-1 px-2 bg-gray-900 border-gray-800  border' />
                <button className='submit-button' type='submit'>Submit</button>
            </form>

        </div>
    );
};

export default AssignmentModalContent;